/**
 * External destinations opened from the presentation.
 * Both open in a new browser tab so the deck stays live behind them.
 */

export const VEXU_PORTAL_URL = 'https://console.vexu.ai'

/**
 * Talab experience URL — drop the live Talab link here and the
 * "Experience Talab" CTA will open it in a new tab.
 */
export const TALAB_URL = ''

export function openExternal(url: string) {
  if (!url) return
  window.open(url, '_blank', 'noopener,noreferrer')
}
